// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-b[data-v-8121436e]{border-bottom:1px solid #f1f5f9!important}.direction-ltr[data-v-8121436e]{direction:ltr!important;text-align:left!important}", ""]);
// Exports
module.exports = exports;
